import { Shapes, Layers, Tag } from "lucide-react";
import { clsx } from "clsx";

export type BuilderSidebarView = "product" | "design" | "assets";

interface LeftIconNavProps {
  activeView: BuilderSidebarView | null;
  onViewChange: (view: BuilderSidebarView) => void;
}

const NAV_ITEMS: { view: BuilderSidebarView; icon: (props: { size: number; strokeWidth: number }) => React.ReactNode; label: string }[] = [
  { view: "product", icon: Tag, label: "Product" },
  { view: "design", icon: Layers, label: "Design" },
  { view: "assets", icon: Shapes, label: "Library" },
];

export const LeftIconNav = ({ activeView, onViewChange }: LeftIconNavProps) => {
  return (
    <div className="w-[48px] flex-shrink-0 flex flex-col items-center p-1.5 gap-1 bg-gray-50 border-r border-gray-200">
      {NAV_ITEMS.map(({ view, icon: Icon, label }) => {
        const isActive = activeView === view;
        return (
          <button
            key={view}
            onClick={() => onViewChange(view)}
            title={label}
            className={clsx(
              "w-10 h-10 flex flex-col items-center justify-center rounded-sm gap-[3px] transition-colors",
              isActive
                ? "bg-gray-200/80 text-[#1a1a1a]"
                : "text-[#8c8c8c] hover:bg-gray-100/80 hover:text-[#333]"
            )}
          >
            <Icon size={16} strokeWidth={1.6} />
            <span className="text-[9px] leading-none font-medium tracking-tight">{label}</span>
          </button>
        );
      })}
    </div>
  );
};
